import React from 'react'

import { useHistory } from 'react-router-dom'

import {
  Container,
  Typography,
  CircularProgress,
  makeStyles,
  useTheme,
  useMediaQuery,
  Button,
} from '@material-ui/core'

import { routes } from 'routes'
import { SafeEnvironment } from 'components'
import CardPlan from './../components/CardPlan'
import useSubscribe from 'hooks/useSubscribe'

import styles from './styles'

const useStyles = makeStyles(styles)

const SubscribeMain = () => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const subscribe = useSubscribe()

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const handleClickSubscribe = (event, plan) => {
    subscribe.addItemCart(plan)
    history.push(routes.subscribe.checkout)
  }

  const handleClickAddToCart = (event, plan) => {
    subscribe.addItemCart(plan)
  }

  return (
    <Container maxWidth="md">
      {!isDesktop && <SafeEnvironment direction="column" />}

      <Typography className={classes.title} variant="h4">
        Escolha o plano ideal para você
      </Typography>

      {subscribe.isLoadingPlans && (
        <div className={classes.progress}>
          <CircularProgress size={60} />
        </div>
      )}

      {!subscribe.isLoadingPlans && !subscribe.plans && (
        <div className={classes.notFound}>
          <Typography color="textSecondary" align="center">
            Nenhum plano disponível no momento.
          </Typography>
        </div>
      )}

      {subscribe.plans && (
        <div className={classes.plansContainer}>
          {subscribe.plans.map(plan => (
            <CardPlan
              plan={plan}
              key={plan.id}
              className={classes.plan}
              expandOnMouseOver
            >
              <Button
                variant="contained"
                color="primary"
                size={isDesktop ? 'medium' : 'large'}
                className={classes.subscribeButton}
                disableElevation
                fullWidth
                onClick={event => handleClickSubscribe(event, plan)}
              >
                Contratar
              </Button>

              <Button
                variant="outlined"
                color="primary"
                size={isDesktop ? 'medium' : 'large'}
                disableElevation
                fullWidth
                onClick={event => handleClickAddToCart(event, plan)}
              >
                Adicionar ao carrinho
              </Button>
            </CardPlan>
          ))}
        </div>
      )}
    </Container>
  )
}

export default SubscribeMain
